export default "__VITE_ASSET__BwTgQws2__"